import React from 'react';
import { graphql } from 'gatsby';
import get from 'lodash/get';
import styled from 'styled-components';
import {
  Text, Picture, spacing, containers
} from '@comicrelief/component-library';
import Layout from '../../components/Layout/Layout';
import SEO from '../../components/SEO/SEO';
import renderRichText from '../../components/RichText/RichText';

const Wrapper = styled.div`
  background: ${({ theme }) => theme.color('grey_light')};
  display: flex;
  flex-direction: column;
`;

const Container = styled.article.attrs({
  'data-test': 'person'
})`
  background: ${({ theme }) => theme.color('white')};
  width: 100%;
  max-width: ${containers.small};
  margin: ${spacing('md')} auto;
  padding: ${spacing('md')};
  @media ${({ theme }) => theme.allBreakpoints('M')} {
    padding: ${spacing('l')} ${spacing('xl')};
  }
`;

const Header = styled.header`
  padding-top: ${spacing('l')};
  text-align: center;
  width: 100%;
  max-width: ${containers.small};
  margin: 0 auto;
`;

const Image = styled.div`
  width: 100%;
  margin: ${spacing('l')} auto;

  @media ${({ theme }) => theme.allBreakpoints('L')} {
    width: 130%;
    margin-left: -15%;
  }
`;

const Person = (props) => {
  const person = get(props, 'data.allContentfulPagePerson.edges[0].node');
  const {
    title, summary, image, path, body, role
  } = person;
  const fallback = image ? image.fallback?.src : null;
  const seoImage = image ? image.seoImage?.src : null;
  const seoSummary = summary !== null && typeof summary.summary !== 'undefined' ? summary.summary : '';
  const fluidImage = image ? image.fluid?.srcSet : null;
  const lowImage = image ? image.placeHolder?.src : null;
  const description = image ? image.description : null;

  return (
    <Layout>
      <SEO title={`${title} | Comic Relief`} description={seoSummary} image={seoImage} pathname={`about-comic-relief/${path}`} article />
      <Wrapper>
        <Header>
          <Text tag="h1" size="xxl" uppercase>
            {title}
          </Text>
          <Text tag="p" size="m" uppercase>
            {role}
          </Text>
        </Header>
        <Container>
          {image ? (
            <Image>
              <Picture
                alt={description}
                image={fallback}
                images={fluidImage}
                imageLow={lowImage}
                objectFit={false}
              />
            </Image>
          ) : null}
          {renderRichText(body, 'white')}
        </Container>
      </Wrapper>
    </Layout>
  );
};

export default Person;

export const pageQuery = graphql`
  query getPerson($slug: String) {
    allContentfulPagePerson(filter: { path: { eq: $slug } }) {
      edges {
        node {
          title
          role
          path
          summary {
            summary
          }
          body {
            raw
          }
          image {
            description
            fluid(cropFocus: FACE, maxHeight: 600, resizingBehavior: FILL, maxWidth: 1050) {
              srcSet
            }
            fallback: fixed {
              src
            }
            placeHolder: fixed(cropFocus: FACE, height: 600, resizingBehavior: FILL, width: 1050, quality: 1) {
              src
            }
            seoImage: resize {
              src
            }
          }
        }
      }
    }
  }
`;
